module.exports = __webpack_public_path__ + "media/mypage/images/menu/spm2-00e0d2b6b35a131c19373265b294eded.png";